import * as React from "react";
import { Skills } from '../../../../shared/components';

interface ProfileSkillsProps {
  skills: Array<any>;
  profile: {
    position_types: Array<string>;
    [prop: string]: any;
  };
  showPositionTypes?: boolean;
}

/**
 * ProfileSkills Component
 * 
 * Wrapper around the shared Skills component specifically for candidate profiles.
 * Displays profile position types and skills with proper Bootstrap styling.
 */
export default function ProfileSkills({ skills, profile, showPositionTypes = true }: ProfileSkillsProps) {
  return (
    <Skills
      skills={skills}
      type="profile"
      data={profile}
      className="px-4"
      showPositionTypes={showPositionTypes}
      variant="soft"
    />
  );
}
